import { styled } from '@linaria/react';

const ViewPort = styled.main`
  padding-bottom: 3.125rem;
`;

export default ViewPort;
